module.exports = __webpack_public_path__ + "img/file-earmark-x.c4a45ef5.svg";